"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeFormOptions = void 0;
const mobx_react_form_1 = __importDefault(require("mobx-react-form"));
const lodash_1 = __importDefault(require("lodash"));
const observer = form => ({ field }) => form.state.options.set({ [field.key]: field.value });
const setProp = (fields, prop) => lodash_1.default.reduce(fields, (obj, val, key) => lodash_1.default.merge(obj, { [key]: prop }), {});
const setObserversProp = (form, fields) => setProp(fields, [{ call: observer(form) }]);
const setCheckboxProp = fields => setProp(fields, 'checkbox');
const getBooleanOptions = form => lodash_1.default.pickBy(form.state.options.options, lodash_1.default.isBoolean);
const makeFormOptions = (form) => {
    const fields = getBooleanOptions(form);
    const types = setCheckboxProp(fields);
    const observers = setObserversProp(form, fields);
    return new mobx_react_form_1.default({
        fields,
        types,
        observers,
    });
};
exports.makeFormOptions = makeFormOptions;
